(() => {
  "use strict";

  const ROOT_SELECTOR = "#easysell";
  let scheduled = false;

  function hasValue(field) {
    if (!field) return false;

    if (field.tagName === "SELECT") {
      return Boolean(field.value);
    }

    return Boolean(field.value && field.value.trim());
  }

  function findIconBox(group, field) {
    const candidates = Array.from(
      group.querySelectorAll("div, span, label")
    );

    return candidates.find((element) => {
      if (element === field || element.contains(field)) return false;

      const containsIcon =
        element.querySelector("svg") ||
        element.querySelector("i") ||
        element.querySelector('[class*="icon"]');

      if (!containsIcon) return false;

      const rect = element.getBoundingClientRect();

      return rect.width > 20 && rect.width < 110;
    });
  }

  function prepareGroup(group) {
    if (!group) return;

    const field = group.querySelector(
      'input:not([type="hidden"]):not([type="submit"]), select, textarea'
    );

    if (!field) return;

    group.classList.add("vizora-field-group");

    const inputColumn =
      field.closest(".es-input-column") ||
      field.parentElement;

    if (inputColumn) {
      inputColumn.classList.add("vizora-input-wrap");
    }

    const updateValueState = () => {
      group.classList.toggle("vizora-has-value", hasValue(field));
    };

    if (!field.dataset.vizoraBound) {
      field.dataset.vizoraBound = "true";

      field.addEventListener("focus", () => {
        group.classList.add("vizora-field-focus");
      });

      field.addEventListener("blur", () => {
        group.classList.remove("vizora-field-focus");
        updateValueState();
      });

      field.addEventListener("input", updateValueState);
      field.addEventListener("change", updateValueState);
    }

    updateValueState();

    if (
      group.classList.contains("es-first_name-group") ||
      group.classList.contains("es-phone-group")
    ) {
      const iconBox = findIconBox(group, field);

      if (iconBox) {
        iconBox.classList.add("vizora-icon-box");
      }
    }
  }

  function enhanceEasySell() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    root.classList.add("vizora-easysell-ready");

    const container = root.querySelector("#es-form-container");
    const form = root.querySelector("#es-form");

    if (container) {
      container.classList.add("vizora-form-card");
    }

    if (form) {
      form.classList.add("vizora-premium-form");
    }

    root.querySelectorAll("#es-form .es-group").forEach(prepareGroup);

    const submitButton = root.querySelector(
      "#es-form-button, .es-cta-btn"
    );

    if (submitButton) {
      submitButton.classList.add("vizora-submit-button");
    }

    const stickyButton = document.querySelector("#es-sticky");

    if (stickyButton) {
      stickyButton.classList.add("vizora-sticky-button");
    }
  }

  function scheduleEnhancement() {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      enhanceEasySell();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      scheduleEnhancement,
      { once: true }
    );
  } else {
    scheduleEnhancement();
  }

  const observer = new MutationObserver(scheduleEnhancement);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener("load", scheduleEnhancement);
})();